import { SubUserRow } from '../types';
import { FC, useCallback } from 'react';
import { Button, ButtonStyles, DefaultFooterComponent, Icons, SelectList, showAlert } from '@silverfort/sf-components';
import { useChangeMatchingPrimaryUser } from '../../../api';
import { usePopup } from '../../../context/PopupProvider';
import { useUsers } from '../../../context/UserManagementContext';

type Props = SubUserRow;

const SubUserManageCell: FC<Props> = ({ id, primaryUserGuid }) => {
    const { openPopup } = usePopup();
    const { mutate } = useUsers();
    const { changeMatchingPrimaryUser } = useChangeMatchingPrimaryUser({
        onSuccess: useCallback(() => {
            mutate();
            showAlert('Successfully updated primary user.', 'success', {
                title: 'Primary user updated'
            });
        }, [mutate]),
        onError: useCallback(() => {
            showAlert('An error occurred while updating the users primary.', 'error', {
                title: 'Failed to change primary user '
            });
        }, [])
    });

    const handleSetAsPrimaryClick = () => {
        openPopup({
            popupClassName: 'w-[360px]',
            title: 'Change primary',
            ContentComponent: () => <span className="font-sf">Are you sure you want to change the primary user?</span>,
            FooterComponent: DefaultFooterComponent,
            FooterComponentProps: {
                primaryButtonProps: {
                    text: 'Change'
                }
            },
            onApprove: () => changeMatchingPrimaryUser(id, primaryUserGuid)
        });
    };

    if (id === primaryUserGuid) {
        return null;
    }

    return (
        <SelectList
            menuProps={{
                anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                transformOrigin: { vertical: 'top', horizontal: 'right' }
            }}
            items={[{ title: 'Set as primary', onClick: handleSetAsPrimaryClick }]}
            id={`sub_user-manage-${id}`}
            triggerProps={{
                iconLeft: Icons.MoreVertical,
                iconSize: 16,
                buttonStyle: ButtonStyles.GhostSolid
            }}
            TriggerComponent={Button}
        />
    );
};

export default SubUserManageCell;
